const STORAGE_KEY = "phone_countries"
const TTL = 6 * 60 * 60 * 1000

export const getCachedCountries = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null

    const parsed = JSON.parse(raw)

    if (!Array.isArray(parsed?.data) || !parsed?.timestamp) return null

    // const expired = Date.now() - parsed.timestamp > TTL;
    // if (expired) {
    //   sessionStorage.removeItem(STORAGE_KEY);
    //   return null;
    // }

    return parsed.data
  } catch {
    return null
  }
}

export const saveCountriesToCache = (data) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        data,
        timestamp: Date.now()
      })
    )
  } catch {}
}
